import chromeSetupBulletsPng from '@listening/assets/astro/images/Chrome-Setup-Bullets.png';
import downloadAppPng from '@listening/assets/astro/images/Download-App.png';
import downloadAppGooglePng from '@listening/assets/astro/images/Download-App-Google.png';
import handSignaturePng from '@listening/assets/astro/images/Hand-Signature.png';
import leftLinesPng from '@listening/assets/astro/images/Left-Lines.png';
import rightLinesPng from '@listening/assets/astro/images/Right-Lines.png';
import sigBlockPng from '@listening/assets/astro/images/Sig-Block.png';
import { createFileRoute } from '@tanstack/react-router';
import { seo } from '@/seo/seo';

export const Route = createFileRoute(
  '/_marketing/_seo/_legacy/setup-extension',
)({
  head: () => ({
    meta: [
      ...seo({
        title: 'Chrome Extension | Listening',
        description:
          'Stream academic papers easily with our Chrome extension. Set it up in minutes and start listening on the go. Download now and elevate your study sessions!',
      }),
    ],
  }),
  component: () => (
    <>
      <div className='hidden overflow-hidden sm:block sm:overflow-visible' />
      <div className='mx-0 mt-[25px] mb-0 flex flex-row items-center justify-center overflow-hidden px-[25px] sm:mb-10 sm:overflow-visible sm:px-10 md:mb-0'>
        <img
          alt='Lines'
          className='mx-0 hidden max-w-full sm:mr-10 sm:block'
          loading='lazy'
          src={leftLinesPng}
          width='190'
        />
        <h1 className='my-0 max-w-[775px] text-center text-[33px] leading-[44px] font-[600] sm:text-[45px] sm:leading-[55px] lg:text-[50px] lg:leading-[62px]'>
          How to&nbsp;Setup
          <br />
          the&nbsp;Chrome Extension
        </h1>
        <img
          alt='Lines'
          className='mx-0 hidden sm:ml-10 sm:block'
          loading='lazy'
          src={rightLinesPng}
          width='190'
        />
      </div>
      <div className='mx-auto mt-[18px] flex max-w-none flex-col items-center sm:mt-0 sm:max-w-[728px] lg:max-w-[940px]'>
        <div className='mt-0 block w-[90%] flex-col items-center justify-center self-center text-center text-[20px] sm:w-[70%] md:mt-[30px] md:flex'>
          <p>Watch this 1 min video to get your Chrome Extension setup:</p>
          <p />
          <p />
        </div>
        <div className='mt-6 w-[70%]' />
        <div>
          <div
            style={{
              overflow: 'hidden',
              borderRadius: '20px',
              width: '640px',
              height: '416px',
            }}
          >
            <iframe
              allowFullScreen
              height='416'
              sandbox='allow-scripts allow-presentation'
              src='https://www.loom.com/embed/5795ff043b8c4c11867361a12d174807?sid=ef7acb42-4780-425c-8d75-587a61b15607'
              title='Loom video'
              width='640'
            />
          </div>
        </div>
        <div className='mt-[35px] flex w-full max-w-full flex-col items-center justify-center overflow-hidden text-[16px] sm:overflow-visible'>
          <a
            className='mt-[30px] block w-[90%] cursor-pointer rounded-[5px] border-0 bg-azure-245 p-[15px] py-[9px] text-center text-[16px] font-[500] text-white no-underline sm:w-[70%] sm:text-[21px]'
            href='https://audioforlistening.s3.amazonaws.com/Listening.io+Chrome+Extension.zip'
            id='purchase-btn-mid'
          >
            Download the Chrome Extension
          </a>
        </div>
        <div className='mt-10 hidden w-[70%] flex-col items-center justify-center self-center text-center text-[18px] sm:text-[20px] md:mt-[30px]'>
          <p>Please download the mobile app here.</p>
          <p>We've sent the Chrome extension via email.</p>
        </div>
        <div className='flex w-4/5 flex-col items-center sm:hidden sm:w-auto sm:flex-row'>
          <p className='mt-[29px] mb-[23px] text-center text-[26px] font-[400]'>
            Download the App
          </p>
          <a
            className='inline-block max-w-full'
            href='https://apps.apple.com/ro/app/listening-read-as-a-podcast/id1635430768'
          >
            <img
              alt='Download App'
              className='mt-px mb-[14px] w-[180px]'
              loading='lazy'
              src={downloadAppPng}
            />
          </a>
          <a
            className='inline-block max-w-full'
            href='https://play.google.com/store/apps/details?id=io.listening.main'
          >
            <img
              alt='Download App Google'
              className='mt-px mb-[14px] w-[180px]'
              loading='lazy'
              src={downloadAppGooglePng}
            />
          </a>
        </div>
        <img
          alt='Chrome Setup Bullets'
          className='mt-[40px] max-w-[50%]'
          loading='lazy'
          src={chromeSetupBulletsPng}
        />
        <div className='mt-[50px] w-3/4 text-[18px] leading-[30px] font-[300]'>
          <span className='font-[Merriweather,_serif] text-[24px] font-bold'>
            M
          </span>
          y name's Derek, founder of Listening. <br />
          <br />
          I'm excited for you to try out our app, as it's been a true labor of
          love. We've spent countless hours designing and developing the app to
          make it as amazing as possible.
          <br />
          <br />I can't wait for you to try it!
          <br />
          <br />
          If you ever have any questions, suggestions, or feedback, please let
          me know! <br />
          <br />I love connecting with users of our product, so don't hesitate
          to reach out.
          <br />
          <br />
          Thanks for trying our app, and I hope you enjoy it!
          <br />
          <br />
          Best wishes,
        </div>
        <img
          alt='Signature'
          className='mt-[30px] ml-[42px] w-[300px] self-start sm:ml-[82px] lg:ml-[118px] xl:ml-[130px]'
          loading='lazy'
          src={handSignaturePng}
        />
        <img
          alt='Sig Block'
          className='my-[50px] ml-[17px] w-4/5 sm:ml-[43px]'
          loading='lazy'
          src={sigBlockPng}
        />
      </div>
    </>
  ),
});
